import PropTypes from 'prop-types';
import React from 'react';
import HotelContactsView from './HotelContactsView';
import HotelContactsForm from './HotelContactsForm';

function getInitialValues(featureList) {
  const initialValues = { features: [] };
  featureList.forEach(feat => {
    initialValues.features.push(feat.key);
  });
  return initialValues;
}

class HotelContacts extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    console.log('handle submit...', values);
    debugger
    const payload = values;
    //this.props.hotel.hotels[0].id
    this.props.addHotelContact(this.props.hotel.id, payload);
    this.handleClose();
  }
  render() {
    if (this.state.isEditing || this.props.isAddHotel) {
      return (
        <HotelContactsForm
          {...this.props}
          onSubmit={this.handleSubmit}
          handleClose={this.handleClose}
        />
      );
    }
    return <HotelContactsView {...this.props} handleEdit={this.handleEdit} />;
  }
}
HotelContacts.propTypes = {
  hotel: PropTypes.object.isRequired,
  addHotelContact: PropTypes.func.isRequired,
};

export default HotelContacts;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelContacts.js